import React, { FC } from 'react'

import { TeamBadge } from 'features/viewerPage/components/Backgrounds/TeamVsTeam/TeamBadge/TeamBadge'
import { type GameWithoutLivestream } from '../../types'

import styles from './TeamVsTeamBackground.module.scss'

type TeamVsTeamBackgroundProps = {
  mediaObject: GameWithoutLivestream
}
export const TeamVsTeamBackground: FC<TeamVsTeamBackgroundProps> = ({
  mediaObject
}) => {
  const homeTeam = mediaObject?.home_team
  const awayTeam = mediaObject?.away_team

  return (
    <div className={styles.Container} data-testid="team-vs-team-background">
      <div className={styles.RightBackground} />
      <div className={styles.InnerContainer}>
        <div className={styles.Teams}>
          <TeamBadge logoUrl={homeTeam?.badge_url} name={homeTeam?.name} />
          <TeamBadge logoUrl={awayTeam?.badge_url} name={awayTeam?.name} />
        </div>
      </div>
    </div>
  )
}
